module.exports = __webpack_public_path__ + "img/6.a4e4a68f.svg";